import { TextLink } from 'Components/shared/TextLink';
import { IS_ELECTRON } from 'Constants/env';
import React from 'react';
import SimpleMarkdown, { ParserRule, ReactOutputRule } from 'simple-markdown';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { Styled } from './buildLinkText.styles';
import { ElectronMarkdownLink } from './ElectronMarkdownLink';

/**
 * @param buildLinkPreview An `action` which should load the link preview for the Message model, given the URI.
 */
export const buildLinkText = (
  buildLinkPreview: (nodeTarget: string) => void
): ParserRule & ReactOutputRule => ({
  ...SimpleMarkdown.defaultRules.link,
  order: 0,
  match: (matchSrc) => {
    return /^(\[[A-z0-9 _]*]\()?((?:(http|https):\/\/)?(?:www\.)?(?:[\w-]+\.)+[a-z]{2,6}(?:\/[^\s]*)?)(\))?/i.exec(
      matchSrc
    );
  },
  parse: (capture) => ({
    content: capture[2],
    target: capture[2],
    title: capture[3],
    originalText: capture[2], // Store the original text without protocol normalization
  }),
  react: (node, _output, state) => {
    // Don't build link preview for mailto links (emails)
    if (!node.target?.startsWith('mailto:')) {
      buildLinkPreview(node.target);
    }

    const originalText: string = node.originalText || node.target;
    // Ensure the href has a protocol
    const linkHref: string = /^https?:\/\//i.test(node.target)
      ? node.target
      : `https://${node.target}`;

    return (
      <Styled.LinkWrapper>
        {IS_ELECTRON ? (
          <ElectronMarkdownLink
            linkHref={linkHref}
            testid={`markdownCompiler-linkText-${state.key}`}
            underline
          >
            {originalText}
          </ElectronMarkdownLink>
        ) : (
          <TextLink
            key={state.key}
            testid={`markdownCompiler-linkText-${state.key}`}
            underline
            href={linkHref}
            onClick={() => {
              window.open(linkHref);
              pushToGTMDataLayer('linkClick');
            }}
          >
            {originalText}
          </TextLink>
        )}
      </Styled.LinkWrapper>
    );
  },
});
